import { CountryCode, IGameEvent } from '@goodgamestudios/cxf-events'
import { IDictionary } from './common'
import { IGameApi } from './cxf'

export interface IStore {
    adStatus?: Record<string, any>
    countryCode: CountryCode
    customizationSuffix: string
    gameApi: IGameApi
    gameEvents: IGameEvent[]
    gameId: string
    instanceId: string
    isTempServer: boolean
    isCanvas: boolean
    language?: string
    lastPurchaseTab: string
    legendLevel?: number
    level: number
    networkId: string
    playerId?: string
    resolvedCustomizationUrl?: string
    sourceId: string
    subscriptionDisabled: boolean
    token?: string
    unreadOfferNotifsCountUrl: string
    xp: number
    zoneId?: string
}

export interface IStorageData {
    // gameId: string
    // networkId: string
    // instanceId: string
    zoneId?: number
    growthFund: {
        lastPopup: IDictionary<number>
    }
}

export interface IProvider<T> {
    get: () => T | undefined
    set: (value: T) => void
}

export const entityProvider = <T>(initial?: T): IProvider<T> => {
    let element = initial
    return {
        get: () => element,
        set: (value) => {
            element = value
        },
    }
}
